module.exports = __webpack_public_path__ + "static/media/glossary_word_ru.4eaed876.jpg";